// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext} from 'react';
import {Lottie} from '../../lib/lottie';
import {img_url} from '../img_url';
import {use_element_size} from '../../lib/screen_util';
// @ts-ignore
import {App_context} from '../../context.js';
import {use_qs} from '../../lib/use_qs';
import Hero_svg from '../../img/hola2023/hero.svg';
import Arc_svg from '../../img/homepage/hero_arc_frame1.svg';
import styles from './hero_arc_animation.module.less';

export const Hero_arc_animation = ()=>{
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const {no_arc_animation} = use_qs();
    const animation = [
        {frames: {from: 0, to: 149}, direction: 1, loop: true},
    ];
    const [w, h] = use_element_size(is_client && {
        xs: [335, 206],
        sm: [335, 206],
        all: [544, 336],
    });
    if (no_arc_animation)
        return <Hero_svg />;
    return <Lottie src={img_url('animation/hero_arc.json')} width={w}
      height={h} autoplay animation={animation} timeout={3000}
      fallback_svg={<Arc_svg className={styles.fallback_svg}/>}/>;
};
